var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilities40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_10905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9375 35.503V18.8438L20 28.4717L5.9375 18.8438V35.503H33.9375Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.3188L5.9375 18.8326L19.9375 28.4719L19.9462 28.4659L10 21.5969L10 16.3188ZM30 21.5436L33.9375 18.8326L30 16.3962V21.5436Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.3188L10.55 16.3188C10.55 16.1194 10.442 15.9355 10.2677 15.8384C10.0934 15.7413 9.88026 15.7462 9.71061 15.8511L10 16.3188ZM5.9375 18.8326L5.6481 18.3649C5.49015 18.4627 5.3922 18.6335 5.38766 18.8192C5.38313 19.0049 5.47261 19.1803 5.6256 19.2856L5.9375 18.8326ZM19.9375 28.4719L19.6256 28.9249C19.8134 29.0542 20.0616 29.0542 20.2494 28.9249L19.9375 28.4719ZM19.9462 28.4659L20.2581 28.9189C20.407 28.8163 20.496 28.6471 20.4962 28.4663C20.4963 28.2855 20.4075 28.1161 20.2587 28.0133L19.9462 28.4659ZM10 21.5969L9.45 21.5969C9.45 21.7776 9.53876 21.9467 9.68745 22.0494L10 21.5969ZM30 21.5436H29.45C29.45 21.7479 29.5633 21.9354 29.7442 22.0305C29.925 22.1255 30.1437 22.1125 30.3119 21.9966L30 21.5436ZM33.9375 18.8326L34.2494 19.2856C34.4024 19.1803 34.4919 19.0049 34.4873 18.8192C34.4828 18.6335 34.3848 18.4627 34.2269 18.3649L33.9375 18.8326ZM30 16.3962L30.2894 15.9285C30.1198 15.8236 29.9066 15.8187 29.7323 15.9158C29.5581 16.0129 29.45 16.1967 29.45 16.3962H30ZM9.71061 15.8511L5.6481 18.3649L6.2269 19.3003L10.2894 16.7866L9.71061 15.8511ZM5.6256 19.2856L19.6256 28.9249L20.2494 28.0189L6.2494 18.3796L5.6256 19.2856ZM20.2494 28.9249L20.2581 28.9189L19.6342 28.0129L19.6256 28.0189L20.2494 28.9249ZM20.2587 28.0133L10.3125 21.1443L9.68745 22.0494L19.6336 28.9185L20.2587 28.0133ZM10.55 21.5969L10.55 16.3188L9.45001 16.3188L9.45 21.5969L10.55 21.5969ZM30.3119 21.9966L34.2494 19.2856L33.6256 18.3796L29.6881 21.0906L30.3119 21.9966ZM34.2269 18.3649L30.2894 15.9285L29.7106 16.8639L33.6481 19.3003L34.2269 18.3649ZM29.45 16.3962V21.5436H30.55V16.3962H29.45Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.50293L30 5.50293V21.5389L20 28.5029L10 21.5967L10 5.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5112 10.8804H16.7258",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5112 8.58203H20.0974",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4636 9.16943V14.5028H27.5124L22.7319 21.8361V16.5028H20.6831L25.4636 9.16943Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_10905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilities40);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilities40.49285438378712daaa3733aef0a95952.svg";
export { ForwardRef as ReactComponent };